<template>
  <div
    class="d-flex p-4"
    style="min-height: calc(100vh - 5rem);overflow: hidden;position: relative;"
    data-cy="pagina-index-container"
  >
    <div
      class="d-flex flex-row justify-content-start justify-content-md-around align-self-center w-100"
      data-cy="pagina-index-conteudo"
    >
      <div class="font-weight-bold text-white" data-cy="secao-principal">
        <div class="d-flex flex-column" data-cy="titulo-principal">
          <h1 data-cy="titulo-agendar">
            <b>Agendar</b>
          </h1>
          <h1 data-cy="titulo-dinamico">
            um<!--
            --><vue-typer
              :text="['a consulta', ' exame', ' retorno']"
              class="text-white"
              data-cy="typer-servicos"
            ></vue-typer>
          </h1>
          <h1 data-cy="titulo-facilidade">
            nunca foi
            <b>tão fácil</b>
          </h1>
        </div>

        <div class="mt-3 d-flex flex-row" data-cy="botoes-servicos">
          <div v-if="organization && organization.exibirConsultaPresencial" data-cy="container-btn-consulta-presencial">
            <b-button
              variant="none"
              :class="
                `btn rounded-0 d-flex text-white align-items-center btn-outline-attendance-color mr-3 ${
                  !mobile ? 'btn-lg' : ''
                }`
              "
              @click="toAppointment"
              data-cy="btn-consulta-presencial"
            >
              <h5 class="font-weight-bold m-0" data-cy="texto-consulta-presencial">Consulta Presencial</h5>
            </b-button>
          </div>
          <div
            v-if="organization && organization.exibirTelemedicina"
            data-cy="container-btn-teleconsulta"
          >
            <b-button
              variant="none"
              :class="
                `btn rounded-0 d-flex text-white align-items-center btn-outline-attendance-color mr-3 ${
                  !mobile ? 'btn-lg' : ''
                }`
              "
              @click="toTele"
              data-cy="btn-teleconsulta"
            >
              <h5 class="font-weight-bold m-0" data-cy="texto-teleconsulta">Teleconsulta</h5>
            </b-button>
          </div>
          <div
            v-if="organization && organization.exibirExames"
            data-cy="container-btn-exame"
          >
            <b-button
              variant="none"
              :class="
                `btn rounded-0 d-flex text-white align-items-center btn-outline-attendance-color mr-3 ${
                  !mobile ? 'btn-lg' : ''
                }`
              "
              @click="toExam"
              data-cy="btn-exame"
            >
              <h5 class="font-weight-bold m-0" data-cy="texto-exame">Exame</h5>
            </b-button>
          </div>
          <div
            v-if="organization && organization.exibirRetorno"
            data-cy="container-btn-retorno"
          >
            <b-button
              variant="none"
              :class="
                `btn rounded-0 d-flex text-white align-items-center btn-outline-attendance-color mr-3 ${
                  !mobile ? 'btn-lg' : 'h6'
                }`
              "
              @click="toReturn"
              data-cy="btn-retorno"
            >
              <h5 class="font-weight-bold m-0" data-cy="texto-retorno">Retorno</h5>
            </b-button>
          </div>
        </div>

        <!-- <div class="mt-3">
          <a
            class="h6 text-white"
            @click.prevent="
              () => {
                media = !media;
              }
            "
            href="#"
          >Dúvidas? Assista nosso passo a passo</a>
        </div>
        <div v-show="media">
          <iframe
            :width="mobile ? width - 35 : 560"
            height="315"
            src="https://www.youtube.com/embed/BggrpKfqh1c?controls=0"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>-->
      </div>
      <div
        :class="['d-none', 'd-lg-block']"
        :style="{ width: 560, heigth: 315 }"
        data-cy="espaco-visual"
      ></div>
    </div>
    <div id="bg-accessory" data-cy="elemento-decorativo-svg">
      <svg
        width="50.142mm"
        height="51.25mm"
        version="1.1"
        viewBox="0 0 50.142 51.25"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        data-cy="svg-decorativo"
      >
        <g transform="translate(26.707 -143.66)">
          <g
            transform="matrix(.15885 0 0 .15885 -23.065 164.31)"
            stroke-width=".54363"
          >
            <path
              d="m159.24 172.97c-4.7013 0.43848-10.616 0.0834-15.128-0.90806-4.9179-1.0807-104.14-28.958-108.3-30.429-13.399-4.7342-24.575-15.875-29.642-29.551-1.2449-3.3596-6.4636-23.464-15.487-59.663l-13.61-54.596 0.14586-4.521c0.30994-9.6063 2.1672-16.391 6.7065-24.497 1.7766-3.1726 4.5429-7.2029 6.1474-8.9562 3.6952-4.0378 76.489-74.648 80.605-78.187 11.532-9.9152 26.915-13.818 41.343-10.488 8.1557 1.8822 107.73 30.171 111.2 31.59 10.744 4.4 20.575 13.797 26.025 24.873 2.3553 4.7873 30.035 114.31 30.237 119.64 0.4665 12.314-3.4058 24.432-10.809 33.827-2.6495 3.3622-79.506 77.989-83.996 81.56-6.3126 5.0196-17.535 9.5656-25.433 10.302z"
              fill="var(--secondary)"
            />
            <path
              d="m172.18 192.19c-4.7013 0.4385-10.616 0.0834-15.128-0.90805-4.9179-1.0807-104.14-28.958-108.3-30.429-13.399-4.7343-24.575-15.875-29.642-29.551-1.2449-3.3596-6.4636-23.464-15.487-59.663l-13.61-54.596 0.14586-4.521c0.30994-9.6063 2.1672-16.391 6.7065-24.497 1.7766-3.1726 4.5429-7.2029 6.1474-8.9562 3.6952-4.0378 76.489-74.648 80.605-78.187 11.532-9.9152 26.915-13.818 41.343-10.488 8.1557 1.8822 107.73 30.171 111.2 31.59 10.744 4.4 20.575 13.797 26.025 24.873 2.3553 4.7873 30.035 114.31 30.237 119.64 0.46652 12.314-3.4058 24.432-10.809 33.827-2.6495 3.3622-79.506 77.989-83.996 81.56-6.3126 5.0195-17.535 9.5656-25.433 10.302z"
              fill="none"
              stroke="#fff"
              stroke-opacity="0.38889"
            />
          </g>
        </g>
      </svg>
    </div>
    <img class="mb-5" id="logo-quark" src="@/assets/images/clinic-round.svg" data-cy="logo-quark-clinic" />
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";

export default {
  name: "index",
  components: {
    VueTyper
  },
  computed: {
    organization() {
      return this.$store.getters.get_organization;
    },
    mobile() {
      return this.$store.getters.width < 768;
    },
    width() {
      return this.$store.getters.width;
    },
    firstRender() {
      return this.$store.firstRender;
    },
    clinicSpecific() {
      return (
        this.$route.query.hasOwnProperty("c") &&
        this.$route.query.hasOwnProperty("clinica")
      );
    }
  },
  methods: {
    toAppointment() {
      this.$store.commit("clear_selected");
      localStorage.setItem("telemedicina", false);
      this.$router.push({
        name: "consulta_convenio",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          ...(this.clinicSpecific
            ? { clinica: this.$route.query.clinica, c: null }
            : {})
        }
      });
    },
    toExam() {
      this.$store.commit("clear_selected");
      localStorage.setItem("telemedicina", false);
      this.$router.push({
        name: "exame_convenio",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          ...(this.clinicSpecific
            ? { clinica: this.$route.query.clinica, c: null }
            : {})
        }
      });
    },
    toTele() {
      this.$store.commit("clear_selected");
      localStorage.setItem("telemedicina", true);

      this.$router.push({
        name: "exame_convenio",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          ...(this.clinicSpecific
            ? { clinica: this.$route.query.clinica, c: null }
            : {})
        }
      });
    },
    toReturn() {
      this.$store.commit("clear_selected");

      this.$router.push({
        name: "return",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          ...(this.clinicSpecific
            ? { clinica: this.$route.query.clinica, c: null }
            : {})
        }
      });
    }
  },
  data() {
    return {
      media: false
    };
  },
  mounted() {
    this.$store.dispatch(
      "set_clinicspecific",
      this.$route.params.hasOwnProperty("c")
    );
    this.$store.dispatch("set_actual", this.$route.fullPath);
  }
};
</script>

<style lang="scss">
@import "../assets/fonts/metropolis/stylesheet.css";
@import "@/main.scss";
</style>
